import { render, staticRenderFns } from "./DigitalSignatureAuthModal.vue?vue&type=template&id=66c66edf&scoped=true&"
import script from "./DigitalSignatureAuthModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DigitalSignatureAuthModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c66edf",
  null
  
)

export default component.exports